(function () {
  'use strict';

  /* ════════════════════════════════════════════════════════════════════
     Logo swap + size sync
     ════════════════════════════════════════════════════════════════════ */
  function initLogoSwap() { /* no-op: branca eliminada via CSS, original sempre visível */ }

  /* ════════════════════════════════════════════════════════════════════
     Announcement Bar: show/hide on scroll (homepage only)
     Bar becomes position:fixed so it never overlaps the header.
     --enable-sticky-announcement-bar toggled so sticky header
     shifts down by barHeight when bar is visible.
     ════════════════════════════════════════════════════════════════════ */
  function initAnnouncementBar() {
    if (!document.body.classList.contains('template-index')) return;

    var annBar = document.querySelector('.shopify-section--announcement-bar');
    if (!annBar) return;

    var barHeight = 0;

    function hideBar() {
      document.body.classList.remove('aip-scrolled');
      document.documentElement.style.setProperty('--announcement-bar-height', '0px');
      document.documentElement.style.setProperty('--enable-sticky-announcement-bar', '0');
    }

    function showBar() {
      /* CSS controls position:fixed — just add class, then measure real height */
      document.body.classList.add('aip-scrolled');
      if (barHeight === 0) {
        barHeight = annBar.offsetHeight || 44;
      }
      document.documentElement.style.setProperty('--announcement-bar-height', barHeight + 'px');
      document.documentElement.style.setProperty('--enable-sticky-announcement-bar', '1');
    }

    hideBar();

    window.addEventListener('scroll', function () {
      if (window.scrollY > 0) showBar();
      else hideBar();
    }, { passive: true });
  }

  /* ════════════════════════════════════════════════════════════════════
     Header scroll class (solid background after scroll)
     ════════════════════════════════════════════════════════════════════ */
  function initHeaderScroll() {
    var storeHeader = document.querySelector('store-header');
    if (!storeHeader) return;
    function update() {
      storeHeader.classList.toggle('aip-header-scrolled', window.scrollY > 0);
    }
    window.addEventListener('scroll', update, { passive: true });
    update();
  }

  /* ════════════════════════════════════════════════════════════════════
     Mega Menu hover open/close
     ════════════════════════════════════════════════════════════════════ */
  function initMegaMenu() {
    var nav = document.querySelector('desktop-navigation');
    if (!nav) return;

    var closeTimer = null;

    function getPanelEl(item) {
      var trigger = item.querySelector('[aria-controls]');
      return trigger ? document.getElementById(trigger.getAttribute('aria-controls')) : null;
    }

    function openItem(item) {
      if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      nav.querySelectorAll('.header__linklist-item.aip-menu-open').forEach(function (el) {
        if (el !== item) closeItem(el, true);
      });
      item.classList.add('aip-menu-open');
      var panel = getPanelEl(item);
      if (panel) {
        panel.removeAttribute('hidden');
        requestAnimationFrame(function () {
          requestAnimationFrame(function () { panel.classList.add('aip-panel-visible'); });
        });
      }
    }

    function closeItem(item, immediate) {
      item.classList.remove('aip-menu-open');
      var panel = getPanelEl(item);
      if (!panel) return;
      panel.classList.remove('aip-panel-visible');
      if (immediate) {
        panel.setAttribute('hidden', '');
      } else {
        setTimeout(function () {
          if (!item.classList.contains('aip-menu-open')) panel.setAttribute('hidden', '');
        }, 260);
      }
    }

    nav.querySelectorAll('.header__linklist-item.has-dropdown').forEach(function (item) {
      item.addEventListener('mouseenter', function () { openItem(item); });
      item.addEventListener('mouseleave', function () {
        closeTimer = setTimeout(function () { closeItem(item, false); }, 100);
      });
    });

    document.querySelectorAll('.mega-menu').forEach(function (panel) {
      panel.addEventListener('mouseenter', function () {
        if (closeTimer) { clearTimeout(closeTimer); closeTimer = null; }
      });
      panel.addEventListener('mouseleave', function () {
        nav.querySelectorAll('.header__linklist-item.aip-menu-open').forEach(function (el) {
          closeItem(el, false);
        });
      });
    });

    document.addEventListener('click', function (e) {
      if (!nav.contains(e.target)) {
        nav.querySelectorAll('.header__linklist-item.aip-menu-open').forEach(function (el) {
          closeItem(el, true);
        });
      }
    });
  }

  /* ════════════════════════════════════════════════════════════════════
     Two-row header: move localization to left nav
     ════════════════════════════════════════════════════════════════════ */
  function initHeaderTwoRow() {
    var storeHeader = document.querySelector('store-header');
    if (!storeHeader) return;
    var inlineNav = storeHeader.querySelector('.header__inline-navigation');
    var locForm   = storeHeader.querySelector('.header__cross-border');
    if (!inlineNav || !locForm) return;

    var clone = locForm.cloneNode(true);
    clone.classList.add('aip-localization-left');
    clone.setAttribute('aria-hidden', 'true');
    inlineNav.prepend(clone);
    locForm.style.display = 'none';
  }

  /* ════════════════════════════════════════════════════════════════════
     Header icons: inject search + wishlist
     Order enforced via CSS order property:
     1. Login  2. Pesquisa  3. Wishlist  4. Carrinho
     ════════════════════════════════════════════════════════════════════ */
  function initHeaderIcons() {
    var iconList = document.querySelector('.header__secondary-links .header__icon-list');
    if (!iconList) return;

    /* Show account/login icon on mobile (theme hides it with hidden-phone) */
    var accountLink = iconList.querySelector('a[href*="/account"], a[href*="/login"]');
    if (accountLink) {
      accountLink.classList.remove('hidden-phone');
      accountLink.style.display = '';
    }

    /* Inject search icon */
    if (!iconList.querySelector('.aip-icon--search')) {
      var searchEl = document.createElement('a');
      searchEl.href = '/search';
      searchEl.className = 'header__icon-wrapper tap-area aip-icon--search';
      searchEl.setAttribute('is', 'toggle-link');
      searchEl.setAttribute('aria-controls', 'search-drawer');
      searchEl.setAttribute('aria-expanded', 'false');
      searchEl.setAttribute('aria-label', 'Buscar');
      searchEl.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/></svg>';
      iconList.appendChild(searchEl);
    }

    /* Inject wishlist icon */
    if (!iconList.querySelector('.aip-icon--wishlist')) {
      var wishEl = document.createElement('a');
      wishEl.href = '/pages/wishlist';
      wishEl.className = 'header__icon-wrapper tap-area aip-icon--wishlist';
      wishEl.setAttribute('aria-label', 'Lista de desejos');
      wishEl.innerHTML = '<svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
      iconList.appendChild(wishEl);
    }
  }

  /* ════════════════════════════════════════════════════════════════════
     Product card hover overlay (collection page)
     ════════════════════════════════════════════════════════════════════ */
  function initProductHover() {
    document.querySelectorAll('.product-item').forEach(function (card) {
      var wrap = card.querySelector('.product-item__image-wrapper');
      if (!wrap) return;

      if (!wrap.querySelector('.aip-col-wishlist')) {
        var heart = document.createElement('button');
        heart.type = 'button';
        heart.className = 'aip-col-wishlist';
        heart.setAttribute('aria-label', 'Favoritar produto');
        heart.setAttribute('aria-pressed', 'false');
        heart.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"><path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/></svg>';
        /* O clique é de aguasdeipanema-wishlist.js, que guarda a lista de
           verdade. Antes o toggle era aqui e não persistia nada. */
        wrap.appendChild(heart);
      }
    });
  }

  /* ════════════════════════════════════════════════════════════════════
     Wishlist toggle — product-card-2026 (home + collection)
     ════════════════════════════════════════════════════════════════════ */
  /* Os corações dos cards passaram a ser tratados por
     assets/aguasdeipanema-wishlist.js, que é quem guarda a lista. O que
     estava aqui só alternava uma classe e se perdia no reload — manter os
     dois seria disputar o mesmo clique. */
  function initWishlistButtons() {
    if (window.aipWishlist) window.aipWishlist.sincronizar();
  }

  /* ════════════════════════════════════════════════════════════════════
     Carousel arrow navigation (home carousels)
     ════════════════════════════════════════════════════════════════════ */
  function initCarouselArrows() {
    document.querySelectorAll('[data-aip-carousel]').forEach(function (wrap) {
      var track   = wrap.querySelector('[data-aip-track]');
      var prevBtn = wrap.querySelector('[data-aip-prev]');
      var nextBtn = wrap.querySelector('[data-aip-next]');
      if (!track) return;

      function cardWidth() {
        var card = track.querySelector('[data-aip-card]');
        if (!card) return 300;
        var gap = parseFloat(getComputedStyle(track).columnGap) || 12;
        return card.offsetWidth + gap;
      }

      if (prevBtn) prevBtn.addEventListener('click', function () {
        track.scrollBy({ left: -cardWidth(), behavior: 'smooth' });
      });
      if (nextBtn) nextBtn.addEventListener('click', function () {
        track.scrollBy({ left: cardWidth(), behavior: 'smooth' });
      });

      function updateArrows() {
        if (prevBtn) prevBtn.disabled = track.scrollLeft <= 4;
        if (nextBtn) nextBtn.disabled = track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
      }

      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    });
  }

  /* ════════════════════════════════════════════════════════════════════
     Video carousel: ONE video playing at a time
     Index-based navigation; arrows + swipe both supported
     ════════════════════════════════════════════════════════════════════ */
  function initVideoCarousel() {
    document.querySelectorAll('[data-aip-vc-wrap]').forEach(function (sectionEl) {
      var track = sectionEl.querySelector('[data-aip-track]');
      if (!track) return;
      var cards = Array.from(track.querySelectorAll('[data-aip-video-card]'));
      if (!cards.length) return;

      var videos      = cards.map(function (c) { return c.querySelector('[data-aip-video]'); });
      var currentIdx  = -1;
      var prevBtn     = sectionEl.querySelector('[data-aip-prev]');
      var nextBtn     = sectionEl.querySelector('[data-aip-next]');
      var lockTimer   = null;
      var isProg      = false; /* true while programmatic scroll is settling */
      var scrollTimer = null;

      /* Configure each video element */
      videos.forEach(function (v, i) {
        if (!v) return;
        v.muted       = true;
        v.loop        = true;
        v.playsInline = true;
        v.preload     = 'none';
        v.removeAttribute('controls');

        var muteBtn = cards[i].querySelector('[data-aip-mute]');
        if (muteBtn) {
          muteBtn.addEventListener('click', function (e) {
            e.preventDefault();
            v.muted = !v.muted;
            muteBtn.classList.toggle('aip-is-unmuted', !v.muted);
            muteBtn.setAttribute('aria-label', v.muted ? 'Ativar som' : 'Silenciar');
          });
        }
      });

      /* Activate a card by index: pause all others, play active */
      function activateCard(idx) {
        if (idx < 0 || idx >= cards.length) return;
        currentIdx = idx;
        cards.forEach(function (card, i) {
          var v = videos[i];
          if (i === idx) {
            card.classList.add('aip-vc-active');
            if (v) v.play().catch(function () {});
          } else {
            card.classList.remove('aip-vc-active');
            if (v) v.pause();
          }
        });
        if (prevBtn) prevBtn.disabled = idx === 0;
        if (nextBtn) nextBtn.disabled = idx === cards.length - 1;
      }

      /* Scroll to card and activate it */
      function goToCard(idx) {
        if (idx < 0 || idx >= cards.length) return;
        var card         = cards[idx];
        var scrollTarget = card.offsetLeft - (track.clientWidth - card.offsetWidth) / 2;
        isProg = true;
        clearTimeout(lockTimer);
        lockTimer = setTimeout(function () { isProg = false; }, 700);
        track.scrollTo({ left: Math.max(0, scrollTarget), behavior: 'smooth' });
        activateCard(idx);
      }

      /* Arrow buttons */
      if (prevBtn) prevBtn.addEventListener('click', function () { goToCard(currentIdx - 1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { goToCard(currentIdx + 1); });

      /* Swipe / drag detection: activate whichever card is closest to center after scroll settles */
      track.addEventListener('scroll', function () {
        if (isProg) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          var trackCenter = track.scrollLeft + track.clientWidth / 2;
          var closest = 0; var closestDist = Infinity;
          cards.forEach(function (card, i) {
            var dist = Math.abs((card.offsetLeft + card.offsetWidth / 2) - trackCenter);
            if (dist < closestDist) { closestDist = dist; closest = i; }
          });
          if (closest !== currentIdx) activateCard(closest);
        }, 120);
      }, { passive: true });

      /* Start first card when section enters viewport */
      var obs = new IntersectionObserver(function (entries) {
        entries.forEach(function (e) {
          if (e.isIntersecting) { goToCard(0); obs.disconnect(); }
        });
      }, { threshold: 0.3 });
      obs.observe(sectionEl);
    });
  }

  /* ════════════════════════════════════════════════════════════════════
     Marquee: normaliza a duração da animação por px/s
     Garante velocidade visual constante independentemente do comprimento
     do texto. O CSS define 15s como placeholder; este código sobrescreve
     com a duração correta baseada na largura real de 1 cópia do conteúdo.
     ════════════════════════════════════════════════════════════════════ */
  function initAnnouncementBarMarquee() {
    var bar = document.querySelector('.aip-announcement-marquee');
    if (!bar) return;
    var track = bar.querySelector('.aip-announcement-marquee__track');
    if (!track) return;

    var copies = parseInt(bar.dataset.mqCopies || '8', 10);
    var spx    = parseFloat(bar.dataset.mqSpx   || '15');   /* s per 1000px */

    function applySpeed() {
      var totalWidth  = track.scrollWidth;
      var oneSetWidth = totalWidth / copies;
      if (oneSetWidth < 1) return;
      var duration = (spx * oneSetWidth) / 1000;
      track.style.animationDuration = duration.toFixed(2) + 's';
    }

    applySpeed();
    /* Re-aplicar se a janela mudar de tamanho */
    window.addEventListener('resize', applySpeed, { passive: true });
  }

  /* ════════════════════════════════════════════════════════════════════
     FILTRAR drawer — ordenação PT-BR nas páginas de coleção
     ════════════════════════════════════════════════════════════════════ */
  function initCollectionSort() {
    var sortBtn = document.getElementById('aip-sort-btn');
    var drawer  = document.getElementById('aip-sort-drawer');
    if (!sortBtn || !drawer) return;

    var overlay  = drawer.querySelector('.aip-sort-drawer__overlay');
    var closeBtn = drawer.querySelector('.aip-sort-drawer__close');

    function open() {
      drawer.setAttribute('aria-hidden', 'false');
      drawer.classList.add('is-open');
      document.body.classList.add('aip-sort-open');
      sortBtn.setAttribute('aria-expanded', 'true');
    }

    function close() {
      drawer.setAttribute('aria-hidden', 'true');
      drawer.classList.remove('is-open');
      document.body.classList.remove('aip-sort-open');
      sortBtn.setAttribute('aria-expanded', 'false');
    }

    sortBtn.addEventListener('click', function () {
      drawer.classList.contains('is-open') ? close() : open();
    });

    if (overlay) overlay.addEventListener('click', close);
    if (closeBtn) closeBtn.addEventListener('click', close);

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) close();
    });

    drawer.querySelectorAll('[data-sort]').forEach(function (opt) {
      opt.addEventListener('click', function () {
        var val = opt.dataset.sort;
        close();
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', val);
        url.searchParams.delete('page');
        window.location.href = url.toString();
      });
    });
  }

  /* ════════════════════════════════════════════════════════════════════
     Locale name capitalization fix
     Shopify retorna "Português (brasil)" com 'b' minúsculo via endonym_name.
     O | capitalize do Liquid também converte "Brasil" → "brasil".
     Corrigimos via DOM: substituímos text nodes folha que contenham a
     string errada, tanto no carregamento inicial quanto em elementos
     inseridos dinamicamente (mobile drawer usa append-body, dropdowns
     do seletor de idioma abrem depois do DOMContentLoaded).
     ════════════════════════════════════════════════════════════════════ */
  function initLocaleCapitalization() {
    var WRONG = 'Português (brasil)';
    var RIGHT  = 'Português (Brasil)';

    function fixTextNodes(root) {
      var walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, null, false);
      var node;
      while ((node = walker.nextNode())) {
        if (node.nodeValue.indexOf(WRONG) !== -1) {
          node.nodeValue = node.nodeValue.replace(WRONG, RIGHT);
        }
      }
    }

    fixTextNodes(document.body);

    new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType === 1) fixTextNodes(node);
          else if (node.nodeType === 3 && node.nodeValue.indexOf(WRONG) !== -1) {
            node.nodeValue = node.nodeValue.replace(WRONG, RIGHT);
          }
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ════════════════════════════════════════════════════════════════════
     Bootstrap
     ════════════════════════════════════════════════════════════════════ */
  document.addEventListener('DOMContentLoaded', function () {
    initAnnouncementBar();
    initAnnouncementBarMarquee();
    initHeaderScroll();
    initMegaMenu();
    // initHeaderTwoRow() — disabled: locale mantida na posição original (direita)
    // initHeaderIcons()  — disabled: ícones originais do tema (sem injeção)
    initProductHover();
    initWishlistButtons();
    initCarouselArrows();
    initVideoCarousel();
    initCollectionSort();
    initLocaleCapitalization();

    /* Item 6 (rodada 4): re-injeta o coração em cards carregados via AJAX
       (carrossel de recomendações, busca preditiva). As funções são idempotentes
       (guardas internos), então re-rodar é seguro. Debounced p/ não pesar. */
    var _aipReinjectT = null;
    new MutationObserver(function () {
      if (_aipReinjectT) return;
      _aipReinjectT = setTimeout(function () {
        _aipReinjectT = null;
        initProductHover();
        initWishlistButtons();
      }, 120);
    }).observe(document.body, { childList: true, subtree: true });
  });
})();
